<legend>{{ 'tkey;userdetail.home.associated_public_phones.header' | translate }}</legend>
<p>{{ 'tkey;shared.device.phone.no_owner.description_text' | translate }}</p>

<ul>
  @for (phone of associatedPublicPhones(); track phone; let i = $index) {
    <li [attr.data-is-deskphone]="isDeskphone(phone)" [attr.data-automation]="'associated-phone'">
      @if (isDeskphone(phone)) {
        <span>
          <a [routerLink]="'/public-phone/' + phone.name" class="me-1">
            <strong data-automation="associated-phone-name">{{ phone.name }}</strong>
          </a>
          <span data-automation="associated-phone-description">{{ phone.description }}</span>
        </span>
      }
      @if (!isDeskphone(phone)) {
        <span>
          <strong data-automation="associated-phone-name" class="me-1">{{ phone.name }}</strong>
          <span data-automation="associated-phone-description">{{ phone.description }}</span>
          @if (!phone.name.includes('CTI')) {
            <span class="ziro-forms-validation-message text-warning d-inline">
              - {{ 'tkey;shared.device.phone.no_owner' | translate }}
            </span>
          }
          @if (!phone.name.includes('CTI')) {
            <ziro-button
              [buttonStyle]="buttonStyles.LINK"
              [dataAutomation]="'associated-devices-fix-it'"
              [label]="
                phone.isUpdating
                  ? 'tkey;shared.device.phone.updating_owner'
                  : 'tkey;shared.html.customizable_fields.text_input.fix_it.label'
              "
              [cssClass]="'ms-1'"
              [isDisabled]="phone.isUpdating"
              (clicked)="onFixItClick(i)"
            ></ziro-button>
          }
          @if (phone.isUpdating) {
            <span class="icon-warning multi-select-loading ms-1" [ngClass]="ziroIcons.SAVING"></span>
          }
        </span>
      }
    </li>
  }
</ul>
